var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBrainCog = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 17,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: "none",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54533 15.1667V13.262C4.34667 11.2773 2 10.2147 2 7.16666C2 4.12 3.818 1.796 7.45467 1.83333C10.0727 1.86133 12.5453 3.35733 12.5453 6.40533L14 8.69066C14 10.2147 12.5453 10.2147 12.5453 10.2147C12.5453 10.2147 12.9093 14.024 9.636 14.024V15.1667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 8.49999C7.68696 8.49999 8.02609 8.35952 8.27614 8.10947C8.52619 7.85942 8.66667 7.52028 8.66667 7.16666C8.66667 6.81304 8.52619 6.4739 8.27614 6.22385C8.02609 5.9738 7.68696 5.83333 7.33333 5.83333C6.97971 5.83333 6.64057 5.9738 6.39052 6.22385C6.14048 6.4739 6 6.81304 6 7.16666C6 7.52028 6.14048 7.85942 6.39052 8.10947C6.64057 8.35952 6.97971 8.49999 7.33333 8.49999Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 9.16667C7.86378 9.16667 8.37248 8.95596 8.74756 8.58089C9.12263 8.20581 9.33334 7.6971 9.33334 7.16667C9.33334 6.63624 9.12263 6.12753 8.74756 5.75246C8.37248 5.37739 7.86378 5.16667 7.33334 5.16667C6.80291 5.16667 6.2942 5.37739 5.91913 5.75246C5.54406 6.12753 5.33334 6.63624 5.33334 7.16667C5.33334 7.6971 5.54406 8.20581 5.91913 8.58089C6.2942 8.95596 6.80291 9.16667 7.33334 9.16667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 2"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 17,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: fill,
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.54533 15.1667V13.262C4.34667 11.2773 2 10.2147 2 7.16666C2 4.12 3.818 1.796 7.45467 1.83333C10.0727 1.86133 12.5453 3.35733 12.5453 6.40533L14 8.69066C14 10.2147 12.5453 10.2147 12.5453 10.2147C12.5453 10.2147 12.9093 14.024 9.636 14.024V15.1667",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 8.49999C7.68696 8.49999 8.02609 8.35952 8.27614 8.10947C8.52619 7.85942 8.66667 7.52028 8.66667 7.16666C8.66667 6.81304 8.52619 6.4739 8.27614 6.22385C8.02609 5.9738 7.68696 5.83333 7.33333 5.83333C6.97971 5.83333 6.64057 5.9738 6.39052 6.22385C6.14048 6.4739 6 6.81304 6 7.16666C6 7.52028 6.14048 7.85942 6.39052 8.10947C6.64057 8.35952 6.97971 8.49999 7.33333 8.49999Z",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 9.16667C7.86378 9.16667 8.37248 8.95596 8.74756 8.58089C9.12263 8.20581 9.33334 7.6971 9.33334 7.16667C9.33334 6.63624 9.12263 6.12753 8.74756 5.75246C8.37248 5.37739 7.86378 5.16667 7.33334 5.16667C6.80291 5.16667 6.2942 5.37739 5.91913 5.75246C5.54406 6.12753 5.33334 6.63624 5.33334 7.16667C5.33334 7.6971 5.54406 8.20581 5.91913 8.58089C6.2942 8.95596 6.80291 9.16667 7.33334 9.16667Z",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 2"
  }));
});
export default SvgIconBrainCog;
export const raw = __webpack_public_path__ + "static/media/icon-brain-cog.e2471c8055715cb6b697c1c1d5581021.svg";